import { Options, Vue } from 'vue-class-component';
import { Inject, Prop, Ref, Watch } from 'vue-property-decorator';
import Popover from '@/shared/components/popover/index.vue';
import store from '@/trust-atcs-app/store';
import { PopoverView } from '@/shared/components/popover/popover';
import FileDragAndDrop from '@/shared/components/file-drag-and-drop/index.vue';
import ConfirmDialogue from '@/shared/components/confirm-dialogue/index.vue';
import { EventEmitter } from 'events';
import { TrustAPI } from '@/shared/modules/trust-api';
import { ComplianceForm } from '@/shared/modules/typescript-trustapi-client/models';


@Options({
  components: {
    Popover,
    FileDragAndDrop,
    ConfirmDialogue
  }
})
export default class FileUploader extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop()
  private question!: any;

  @Prop()
  private isFileUploadOptional!: false;

  private newWording = '';
  private obj: PopoverView = null as any;

  private fileList: Array<File> = [];

  private uploading = false;
  private uniqueIdName = null as any;

  @Ref('fileDropAndDrop') readonly fileDropAndDrop!: any;

  @Watch('question.responses')
  private onFileListChanged(): void {
    console.log('fileList changed: ', this.question.responses.length);
    this.$emit('validForm', this.validForm());
  }

  created(): void {
    const content = store.getters.getPopovers;
    this.newWording = this.question.wording;
    if (this.question.wording.match(/--{{([^)]+)}}--/)) {
      const popovers = this.question.wording.match(/--{{([^)]+)}}--/)[1];
      this.obj = content.filter((x: any) => x.key == popovers)[0];
      this.newWording = this.question.wording.replace('--{{' + popovers + '}}--', '');
    }
    this.$emit('validForm', this.validForm());
  }

  mounted(): void {
    this.$nextTick(() => {
      this.$emit('validForm', this.validForm());
      this.uniqueIdName = 'fileDropAndDrop' + this.question.id;
      // this.eventCtrl.on(this.uniqueIdName + 'reset-list', this.resetFileList);
    });
  }


  // beforeUnmount(): void {
  //   this.eventCtrl.removeListener(this.uniqueIdName + 'reset-list', this.resetFileList);
  // }

  private validForm(): boolean {
    return this.question.responses?.length > 0 || this.isFileUploadOptional;
  }

  private fileInputChanged(fileList: Array<File>): void {
    this.fileList = fileList;
    this.$emit('formChanged', this.fileList);
    this.fileListChanged(fileList, this.question.id);
    // this.$emit('validForm', this.validForm());
    this.fileList = [];
  }


  private deleteFile(id: number, removeOnly: boolean): void {
    const _confirm: any = this.$refs.confirmDeleteDialogue;
    _confirm.show({
      title: 'Delete File',
      message: 'Are you sure you want to delete this file?',
      okButton: 'Delete',
      cancelButton: 'Cancel',
    }).then((res: any) => {
      if (res) {
        this.question.responses =
        this.question.responses.filter((x: any) => x.answerNumber != id);
        // this.eventCtrl.emit('save-section', false, true);
        // this.$emit('deleteFile', id);
      }
    })
  }

  private resetFileList(): void {
    try {
      this.fileDropAndDrop.selectedFiles = [];
    } catch (err) {
      console.log(err);
    }
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }


  private fileListChanged(fileList: Array<File>, id: number): void {
    this.fileList = fileList;
    this.uploadAllFiles(this.fileList, id);
  }


  // private async deleteFileFromServer(id: number, removeOnly: boolean): Promise<void> {
  //   if (removeOnly) {
  //     this.uploadedFileList = this.uploadedFileList.filter(x => x.id !== id);
  //     this.eventCtrl.emit('show-snackbar', 'success', 'File removed.');
  //     return;
  //   } else {
  //     try {
  //       await this.apiService.FileAtcsApi?.apiV2FileAtcsAdminDeleteFileFileIdDelete(id);
  //       this.uploadedFileList = this.uploadedFileList.filter(x => x.id !== id);
  //       this.eventCtrl.emit('show-snackbar', 'success', 'File removed.');
  //     } catch (err) {
  //       // this.ai.trackException('Error on delete file: ' + JSON.stringify(err));
  //       this.eventCtrl.emit('show-snackbar', 'error', 'Error on delete file: ' + err);
  //     }
  //   }

  // }


  private async uploadAllFiles(fileList: Array<File>, id: number): Promise<void> {
    const allRequests: Array<Promise<boolean>> = [];
    this.uploading = true;
    try {
      if (fileList.length > 0) {
        fileList.forEach((x) => allRequests.push(this.uploadFile(x, id)));
        await Promise.all(allRequests);
        this.eventCtrl.emit('show-snackbar', 'success', 'File(s) uploaded');
        this.fileList = [];
        this.resetFileList();
        // this.eventCtrl.emit('fileDropAndDrop' + this.formPartBData.controlledMoney.atcsMainQuestions[id].id + 'reset-list');
      }
      // this.validationForm(id, true);
    } catch (err: any) {
      // this.ai.trackException('Error on upload file: ' + JSON.stringify(err));
      this.eventCtrl.emit('show-snackbar', 'error', 'Error on upload file(s)');
    } finally {
      this.uploading = false;
    }
  }

  private async uploadFile(file: File, id: number): Promise<boolean> {
    try {
      const fileStr = await this.fileToString(file);
      const body = {
        complianceFormId: this.complianceFormB.id,
        fileName: file.name,
        fileExtension: file.name,
        fileDataUrl: fileStr,
        id: ''
      };
      const res: any = await this.apiService.FileAtcsApi?.apiV2FileAtcsSaveComplianceFormFilePost(body);
      body.id = res.data.data;
      body.fileDataUrl = '';
      // this.uploadedFileList.push(body);
      this.question.responses.push(
        {
          id: 0,
          wording: file.name,
          relatedId: res.data.data,
          relatedTable: '[Data].[File]',
          answerNumber: res.data.data,
        }
      );
      this.$emit('validForm', this.validForm());
      return Promise.resolve(true);
    } catch (err) {
      console.log(err);
      // this.ai.trackException('Error on upload file: ' + JSON.stringify(err));
      this.eventCtrl.emit('show-snackbar', 'error', 'Error on save file: ' + err);
      return Promise.reject(true);
    }
  }

  private fileToString(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        return resolve(reader.result as string);
      };

      reader.onabort = () => {
        return reject();
      }

      reader.onerror = () => {
        return reject();
      }
    });
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }

}


